import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import MyModalHeader from "../ModalHeader";
import Loader from "../Loader";
import { showMessage } from "../Message";
import "./styles.css";
import ButtonAction from "../ButtonAction";
import { set } from "local-storage";
import { apiCall } from "../../../helpers/ApiCalls";

const ModalDocumentacion = (props) => {
  const {
    title = "Documentación",
    path = "",
    repo = "epod5",
    withCache = true,
    format_html = false,
  } = props;
  const [show, setShow] = useState(false);
  const [documentationContent, setDocumentationContent] = useState("");
  const [docReady, setDocReady] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    async function loadDocumentacion() {
      try {
        setDocReady(false);

        const obtenerDocumentacion = await apiCall("GET", "/get_git_resource");

        if (!obtenerDocumentacion.success) {
          throw new Error(obtenerDocumentacion.message);
        }

        const originalMd = obtenerDocumentacion.data;

        let documentacion = "";
        const startMarker = "# \\[TI]";
        const nextH1Regex = /^[ \t]*# /gm;
        const ultimaRegex = /^[^\S\r\n]\s*Última actualización:.*$/m;

        const ultimaMatch = originalMd.match(ultimaRegex);
        const startIndex = originalMd.indexOf(startMarker);

        if (startIndex !== -1) {
          nextH1Regex.lastIndex = startIndex + startMarker.length;
          const match = nextH1Regex.exec(originalMd);
          const endIndex = match ? match.index : originalMd.length;

          documentacion =
            originalMd.slice(0, startIndex) + originalMd.slice(endIndex);
        } else {
          documentacion = originalMd;
        }

        // Convertimos markdown a HTML (sin la línea de última actualización)
        const documentacionSinTIRequest = await apiCall("POST", "/md_to_html", {
          markdown: documentacion,
        });

        if (!documentacionSinTIRequest.success) {
          throw new Error(documentacionSinTIRequest.message);
        }

        documentacion = documentacionSinTIRequest.data;

        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(documentacion, "text/html");

        const codeBlocks = htmlDoc.querySelectorAll("pre");

        codeBlocks.forEach((pre, i) => {
          const wrapper = htmlDoc.createElement("div");
          wrapper.className = "codigo-bloque";

          const button = htmlDoc.createElement("button");
          button.className = "toggle-codigo";
          button.textContent = "Ocultar";
          button.setAttribute("data-index", i);

          wrapper.appendChild(button);
          wrapper.appendChild(pre.cloneNode(true));

          pre.replaceWith(wrapper);
        });

        // Última actualización div
        if (ultimaMatch) {
          const container = htmlDoc.createElement("div");
          container.style.display = "flex";
          container.style.flexDirection = "column";
          container.style.justifyContent = "flex-end";
          container.style.marginTop = "40px";
          container.style.color = "#999";
          container.style.fontSize = "0.9em";

          const linea1 = htmlDoc.createElement("div");
          linea1.textContent = ultimaMatch[0];

          const linea2 = htmlDoc.createElement("div");
          linea2.textContent = `Recuperado de: ${repo}/${path}`;

          container.appendChild(linea1);
          container.appendChild(linea2);
          htmlDoc.body.appendChild(container);
        }

        documentacion = htmlDoc.body.innerHTML;

        setDocumentationContent(documentacion);
        setDocReady(true);
      } catch (error) {
        console.error("Error loading documentation:", error);
        showMessage("Error cargando la documentación", "error");
      } finally {
        setDocReady(true);
        setError(false);
      }
    }

    if (!show) return;

    if (!path || !repo) {
      setError(true);
      return;
    }

    loadDocumentacion();

    //eslint-disable-next-line
  }, [show]);

  useEffect(() => {
    if (!docReady) return;

    const handler = (e) => {
      if (e.target.classList.contains("toggle-codigo")) {
        const pre = e.target.nextElementSibling;
        if (!pre) return;

        const isVisible = pre.style.display !== "none";
        pre.style.display = isVisible ? "none" : "block";
        e.target.textContent = isVisible ? "Expandir" : "Ocultar";
      }
    };

    document
      .querySelector(".epod5_modal-documentacion")
      ?.addEventListener("click", handler);

    return () => {
      document
        .querySelector(".epod5_modal-documentacion")
        ?.removeEventListener("click", handler);
    };
  }, [docReady]);

  function renderModalContent() {
    if (error) {
      return (
        <span>
          Faltan parámetros para mostrar la documentación correctamente.
          Contacta a Desarrollo.
        </span>
      );
    }

    if (!docReady) {
      return (
        <Row className="epod5_modal-documentacion">
          <Col style={{ minHeight: "1200px" }}>
            <Loader />
          </Col>
        </Row>
      );
    }

    return (
      <Row className="epod5_modal-documentacion">
        <Col>
          <div dangerouslySetInnerHTML={{ __html: documentationContent }} />
        </Col>
      </Row>
    );
  }

  return (
    <>
      <ButtonAction
        onClick={handleShow}
        showBadge={false}
        tooltip={"Ver Documentación"}
      >
        <span className="fa fa-info-circle" />
      </ButtonAction>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
      >
        <MyModalHeader handleHide={handleClose}>{title}</MyModalHeader>
        <Modal.Body>{renderModalContent()}</Modal.Body>
      </Modal>
    </>
  );
};

export default ModalDocumentacion;
